import { LicenseTester } from "@mcleod/core";
import { LMEGeneralSettings } from "@mcleod/general";
import { AutogenLayoutMappingControl } from "./autogen/AutogenLayoutMappingControl";

export class MappingControl extends AutogenLayoutMappingControl {

    override onLoad(): void | Promise<void> {
        const isPartialShipmentLicensed = LicenseTester.testPackage("com.tms.client.loadmaster.ltl");
        const manfiestingEnabled = LMEGeneralSettings.getSingleton().getDispatchControl()["enable_manifesting"] === "Y";
        this.textboxPartialShipmentVendor.visible = isPartialShipmentLicensed && manfiestingEnabled;
    }

}
